import { CSSProperties } from 'react';
import { withIcon } from './withIcon';

const PlayIconSvg = ({ style }: { style?: CSSProperties }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      d="M24 0C10.7453 0 0 10.7452 0 24C0 37.2548 10.7453 48 24 48C37.2547 48 48 37.2548 48 24C48 10.7452 37.2547 0 24 0ZM32.295 25.2722L20.295 32.7722C20.0522 32.9238 19.7761 33 19.5 33C19.2499 33 18.9994 32.9378 18.7727 32.8118C18.2959 32.5474 18 32.0456 18 31.5V16.5C18 15.9544 18.2959 15.4526 18.7727 15.1882C19.2495 14.9224 19.8325 14.9385 20.295 15.2278L32.295 22.7278C32.7334 23.0025 33 23.483 33 24C33 24.517 32.7334 24.9976 32.295 25.2722Z"
      fill="currentColor"
    />
  </svg>
);

export const PlayIcon = withIcon(PlayIconSvg);
